import { H5 } from "@sellar-io/components";
import { useDebounce } from "use-debounce";
import { useShallow } from "zustand/react/shallow";
import { ListElement } from "../../../../components";
import { InfiniteList } from "../../../../components/infiniteLoading/InfiniteList";
import { ORDER_BUYER } from "../../../../constants/routes";
import { useEvents } from "../../../../hooks";
import { useSupplierList } from "../../../../hooks/api/v2/supplier/useSupplierList";

import { useSupplierListStore } from "../SupplierTable/SupplierListStore";
import { NonConnectedSupplierListItem } from "./NonConnectedSupplierListItem";

export const NonConnectedSupplierList = () => {
  const { track } = useEvents();
  const { search } = useSupplierListStore(
    useShallow((state) => ({
      search: state.search,
    })),
  );

  const [debouncedSearchValue] = useDebounce(search, 500);
  const suppliersQuery = useSupplierList(
    {
      limit: 20,
      query: [
        {
          type: "connected",
          modifier: "EQUALS",
          value: false,
        },
      ],
      search: debouncedSearchValue,
    },
    {
      enabled: debouncedSearchValue.length > 1,
    },
  );

  return (
    <>
      {!!suppliersQuery.data?.pages[0]?.length && (
        <div className={"mt-8"}>
          <H5 className={"mb-4"}>Results from the Market: </H5>
          <InfiniteList
            query={suppliersQuery}
            className={"mw-[900px] flex flex-col gap-2"}
          >
            {suppliersQuery.data.pages.map((page) =>
              page.map((supplier) => (
                <ListElement
                  navigation="child"
                  promptText={"See details"}
                  to={ORDER_BUYER.href({
                    supplierIdOrUrlId: supplier.urlId,
                  })}
                  key={supplier.id}
                  className={
                    "rounded-lg border border-solid border-neutral-200"
                  }
                  onClick={async () =>
                    await track("Supplier Clicked From Connections", {
                      supplierId: supplier.id,
                      supplierName: supplier.Business.name,
                    })
                  }
                >
                  <NonConnectedSupplierListItem supplier={supplier} />
                </ListElement>
              )),
            )}
          </InfiniteList>
        </div>
      )}
    </>
  );
};
